import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "src/environments/environment";
import { Payment } from "../models/payment";
import { PaymentSource } from "../models/payment-source";
import { dateToDB, dateToView } from "../shared/utils";

@Injectable({
    providedIn: 'root'
})
export class AccountingService {
    private readonly _baseUrl = `${environment.api}/accounts`;

    constructor(private http: HttpClient) { }

    public addPayment = async (data: any): Promise<Payment> => {
        data.date = dateToDB(data.date);
        const payment = await firstValueFrom(this.http.post<Payment>(`${this._baseUrl}/add-payment`, data));
        payment.date = dateToView(payment.date)!;
        return payment;
    }

    public updatePayment = async (data: any): Promise<Payment> => {
        data.date = dateToDB(data.date);
        const payment = await firstValueFrom(this.http.put<Payment>(`${this._baseUrl}/update-payment`, data));
        payment.date = dateToView(payment.date)!;
        return payment;
    }

    public deletePayment = async (data: any) => {
        return await firstValueFrom(this.http.delete<string>(`${this._baseUrl}/delete-payment`, { body: { data } }));
    }

    public allSources = async (): Promise<PaymentSource[]> => {
        return await firstValueFrom(this.http.get<PaymentSource[]>(`${this._baseUrl}/all-sources`));
    }
}